/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_UnreadableInputs */



/**
* | output |
* | --- |
* | "This report's stored total could not be read, so the figures below are not a reliable bill." |
*
* @param {Report_UnreadableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_unreadable = /** @type {((inputs?: Report_UnreadableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_UnreadableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der gespeicherte Gesamtbetrag dieses Berichts konnte nicht gelesen werden, die Zahlen unten sind daher nicht als Rechnung belastbar.")
	return /** @type {LocalizedString} */ ("This report's stored total could not be read, so the figures below are not a reliable bill.")
});